import React from 'react'

import { isToday } from 'date-fns'

import type { BasicWidgetProps } from '../../types'
import { SingleNumberWidget } from '../../BaseComponents/SingleNumberWidget'
import { useGetContactsByStatusQuery, CardType } from '@edge/spark/io-dashboards'

const MyContactLogFollowups = ({
    config: { text = 'Today', secondaryText = 'Follow-Ups Total' },
    widgetId,
    handleConfig,
    readonly,
    handleDisplayDetails,
}: BasicWidgetProps): React.ReactElement => {
    const { data, loading } = useGetContactsByStatusQuery({
        variables: {
            statusCode: 'followup',
            forFollowUp: true,
        },
    })

    const { list } = data?.auction?.contactManagement?.contacts || {}

    let count = 0
    const totalCount = list?.length
    let dateStringToDate: Date

    list?.forEach((contact) => {
        if (typeof contact?.followUpDate === 'string') {
            dateStringToDate = new Date(contact?.followUpDate)
            if (isToday(dateStringToDate)) {
                count += 1
            }
        }
    })

    return (
        <SingleNumberWidget
            action={{
                text: 'View Follow-Ups',
                link: `/myContactLogFollowups`,
            }}
            cardType={CardType.FOLLOW_UP}
            number={count}
            text={text}
            secondaryText={`${totalCount || ''} ${secondaryText}`}
            loading={loading}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
            handleDisplayDetails={handleDisplayDetails}
        />
    )
}

export default MyContactLogFollowups
